module.exports = __webpack_public_path__ + "static/media/andronicos.5c7130fb.svg";